<div class="spinner-container">
    <ng-container *ngIf="title">
        {{ title | translate }}
    </ng-container>

    <mat-spinner
        *ngIf="!custom; else customSpinner"
        [ngClass]="{
            bigSize: !smallSize,
            smallSize: smallSize,
        }"></mat-spinner>
</div>

<ng-template #customSpinner>
    <mat-progress-spinner mode="indeterminate" [diameter]="size" [strokeWidth]="strokeWidth"> </mat-progress-spinner>
</ng-template>
